import { IPhone } from '../types/developer/contacts';

export const isCorrectPhoneObject = (phone?: IPhone | null): boolean => {
  return !!(phone && phone.countryCode && phone.code && phone.number);
};
